import React, { useMemo } from "react";

import { SecondaryButton } from "components/Form/Button";
import { MultiButton } from "components/Button";
import { Settings } from "constants/settings";
import { MultiButtonOptionProps } from "components/Button/MultiButton/types";
import { useFormikContext } from "formik";

interface FooterProps {
  onClose: () => void;
  isEdit?: boolean;
}

export function Footer(props: FooterProps) {
  const { onClose, isEdit = false } = props;

  const { submitForm } = useFormikContext();

  const addButtons: MultiButtonOptionProps[] = useMemo(
    () => [
      {
        title: "Add",
        onClick: submitForm,
      },
      {
        title: "Add & Receipt",
        onClick: submitForm,
      },
    ],
    [submitForm],
  );
  const updateButtons: MultiButtonOptionProps[] = useMemo(
    () => [
      {
        title: "Update",
        onClick: submitForm,
      },
      {
        title: "Update & Receipt",
        onClick: submitForm,
      },
    ],
    [submitForm],
  );

  return (
    <div className="flex flex-1">
      <div className="flex  flex-1">
        <SecondaryButton type="button" onClick={onClose}>
          Close
        </SecondaryButton>
      </div>

      <div className="flex flex-1">
        {isEdit ? (
          <MultiButton
            stickySetting={Settings.paymentModalUpdateAction}
            buttons={updateButtons}
            fullWidth
          />
        ) : (
          <MultiButton
            stickySetting={Settings.paymentModalAddAction}
            buttons={addButtons}
            fullWidth
          />
        )}
      </div>
    </div>
  );
}
